import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { projectApi } from "../api/projects";
import { projectContentApi, ProjectContent } from "../api/projectContent";
import { ApiResponse } from "../api/http";
import { requireData } from "./http";
export const useAccessibleProjects = () =>
  useQuery({
    queryKey: ["projects", "accessible"],
    queryFn: () => projectApi.list().then(requireData),
  });
export const useProjectContent = (project: string) =>
  useQuery({
    queryKey: ["project-content", project],
    queryFn: () => projectContentApi.list(project).then(requireData),
    enabled: !!project,
  });
export const useContentAction = (project: string) => {
  const cache = useQueryClient();
  return useMutation({
    mutationFn: (action: () => Promise<ApiResponse<ProjectContent>>) =>
      action().then(requireData),
    onSuccess: () =>
      cache.invalidateQueries({ queryKey: ["project-content", project] }),
  });
};
